<div class="row">
    <div class="col-lg-12">
        <h5>My ROCKs</h5>

        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    style="height: 250px"
                    (initialized)="grid.initialize(mainGrid)"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                    [itemFormatter]="gridItemFormatter"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Due'" [binding]="'dueDate'" [width]="105" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Source'"
                        [binding]="'meetingName'"
                        [width]="200"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ROCK'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Done'"
                        [binding]="'doneDate'"
                        [width]="125"
                        [editor]="inputDate"
                        [isRequired]="false"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
                <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
            </div>
        </div>
    </div>
</div>
<div class="row" style="margin-top: 5px">
    <div class="col-lg-12" style="height: 225px">
        @if (grid.selectedItem) {
            <div class="h-100 d-flex flex-column">
                <h6 style="flex-shrink: 0">{{ grid.selectedItem?.name }}</h6>
                <div class="flex-grow-1" style="min-height: 0">
                    <quill-view
                        style="display: block; height: 188px"
                        [content]="grid.selectedItem?.details ?? 'No Details'"
                        theme="snow"
                    ></quill-view>
                </div>
            </div>
        } @else {
            <h6 style="flex-shrink: 0">Select ROCK above</h6>

            <div class="d-flex align-items-center justify-content-center h-100" style="border: 1px solid lightgray; max-height: 189px">
                <div class="text-center">
                    <div class="mb-3">
                        <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                    </div>
                    <h5 class="text-muted mb-2">No ROCK Selected</h5>
                    <p class="text-muted mb-0">Select a ROCK from the list to view its details</p>
                </div>
            </div>
        }
    </div>
</div>
